// extracted by mini-css-extract-plugin
export var blink = "_styles-module--blink--xwWj5";
export var text = "_styles-module--text--E+T1G";